import { render, staticRenderFns } from "./CurvaSGrafico.vue?vue&type=template&id=96a4df3e&scoped=true&"
import script from "./CurvaSGrafico.vue?vue&type=script&lang=js&"
export * from "./CurvaSGrafico.vue?vue&type=script&lang=js&"
import style0 from "./CurvaSGrafico.vue?vue&type=style&index=0&id=96a4df3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a4df3e",
  null
  
)

export default component.exports